import { Menu as MenuCore } from '@studiometa/ui';
import MenuBtn from './MenuBtn.js';

export default class Menu extends MenuCore {
  static config = {
    ...MenuCore.config,
    emits: ['open'],
    components: {
      ...MenuCore.config.components,
      MenuBtn,
    }
  }

  mounted() {
    super.mounted();
    this._boundHandleVariantChange = this.handleVariantChange.bind(this);
    this._boundHandleVariantLinkClick = this.handleVariantLinkClick.bind(this);
    document.addEventListener('variant:change', this._boundHandleVariantChange);
    document.addEventListener('click', this._boundHandleVariantLinkClick);
    this.restoreScrollPosition();
  }

  destroyed() {
    document.removeEventListener('variant:change', this._boundHandleVariantChange);
    document.removeEventListener('click', this._boundHandleVariantLinkClick);
  }

  /**
   * Gère les clics sur les liens de variants
   */
  handleVariantLinkClick(e) {
    const link = e.target.closest('a[href*="?variant="]');
    if (link) {
      this.saveScrollPosition();
    }
  }

  /**
   * Sauvegarde la position de scroll actuelle
   */
  saveScrollPosition() {
    const scrollY = window.scrollY;
    sessionStorage.setItem('scrollY', scrollY.toString());
  }

  handleVariantChange() {
    this.saveScrollPosition();
    this.close();
  }

  /**
   * Restaure la position de scroll sauvegardée dans sessionStorage
   */
  restoreScrollPosition() {
    const savedScrollY = sessionStorage.getItem('scrollY');

    if (savedScrollY) {
      const scrollPosition = parseInt(savedScrollY, 10);

      // Utiliser scrollTo avec behavior smooth pour une meilleure UX
      window.scrollTo({
        top: scrollPosition,
        behavior: 'instant'
      });

      sessionStorage.removeItem('scrollY');
    }
  }

  /**
   * Close other non-parent menu items on menu items open.
   */
  onMenuListItemsOpen(index) {
    super.onMenuListItemsOpen(index);
    this.$emit('open');
  }
}
